class FeaturedProductsBanner extends HTMLElement {
  constructor() {
    super();

    const splideElement = this.querySelector(".splide");
    if (!splideElement) {
      return;
    }
    const splideId = splideElement.getAttribute("id");
    document.addEventListener("DOMContentLoaded", () => {
      this.splide = new Splide("#" + splideId, {
        type: "loop",
        perPage: 1,
        perMove: 1,
        updateOnMove: true,
        snap: true,
        drag: true,
        trimSpace: false,
        pagination: true,
        arrows: false,
        flickPower: 100,
        flickMaxPages: 1,
        focus: 0,
        clones: 1,
      });

      this.splide.mount();

      const prevButtons = this.querySelectorAll(
        ".pdp-media-indicators__button_previous"
      );
      if (prevButtons.length) {
        prevButtons.forEach((button) => {
          button.addEventListener("click", () => {
            this.splide.go("<");
          });
        });
      }

      const nextButtons = this.querySelectorAll(
        ".pdp-media-indicators__button_next"
      );
      if (nextButtons.length) {
        nextButtons.forEach((button) => {
          button.addEventListener("click", () => {
            this.splide.go(">");
          });
        });
      }
    });
  }
}

customElements.define("featured-products-banner", FeaturedProductsBanner);
